import React from "react";
import BrandLogo from '../assets/BrandLogo.png'
const Loading = () => {
  return (
    <>
      {/* Inline styles for animations */}
      <style>
        {`
          @keyframes zoomInOut {
            0%, 100% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.2);
            }
          }

          @keyframes dotAnimation {
            0% {
              opacity: 0;
            }
            15% {
              opacity: 1;
            }
            60% {
              opacity: 1;
            }
            80% {
              opacity: 0;
            }
            100% {
              opacity: 0;
            }
          }

          .zoom-animation {
            animation: zoomInOut 1.8s ease-in-out infinite;
          }

          .dot {
            font-size: 28px;
            line-height: 1;
            opacity: 0;
            animation: dotAnimation 3s infinite;
          }

          .dot1 {
            animation-delay: 0s;
          }
          .dot2 {
            animation-delay: 0.3s;
          }
          .dot3 {
            animation-delay: 0.6s;
          }
          .dot4 {
            animation-delay: 0.9s;
          }
        `}
      </style>

      {/* Loader UI */}
      <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
        <div className="flex flex-col items-center gap-4">

          {/* Zoom In / Out Image */}
          <img
            src={BrandLogo}  
            alt="Loading"
            className="w-24 h-24 zoom-animation"
          />

          {/* Loading Text + Animated Dots */}
          <div className="flex items-center text-lg font-semibold text-gray-700">
            <span>Loading</span>

            <span className="flex ml-2">
              <span className="dot dot1">.</span>
              <span className="dot dot2">.</span>
              <span className="dot dot3">.</span>
              <span className="dot dot4">.</span>
            </span>
          </div>

        </div>
      </div>
    </>
  );
};

export default Loading;
